import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ErrorBoundary } from "./components/ErrorBoundary.js"
import { GlobalErrorOverlay } from "./components/GlobalErrorOverlay.js"
import { ScrollToTop } from "./components/ScrollToTop.js"
import { AdminPage } from "./features/admin/AdminPage.js"
import { BenefitListPage } from "./features/benefit/BenefitListPage.js"
import { CompanyPage } from "./features/company/CompanyPage.js"
import { DisclaimerPage } from "./features/legal/DisclaimerPage.js"

export function App() {
  return (
    <ErrorBoundary>
      <GlobalErrorOverlay />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<BenefitListPage />} />
          <Route path="/companies/:id" element={<CompanyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
